// extracted by mini-css-extract-plugin
module.exports = {"logoImg":"SideMenu_logoImg__1q3zI","test":"SideMenu_test__2dz4N","toggleBtn":"SideMenu_toggleBtn__2ULno"};